module.exports = __webpack_public_path__ + "img/banner.6129edfc.png";